import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';

export function usePromotionCycleList() {
    const { executeAction } = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: promotionService.cycle.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            transformResponse: async (list: any[]) => {
                const itemIds = new Set(list.map(cycle => cycle.promotionPlanId));
                const promotionPlanNames = await getPromotionPlanNameList(itemIds);

                return list.map(cycle => {
                    return {
                        ...cycle,
                        promotionPlanName: promotionPlanNames.get(cycle.promotionPlanId),
                        promotionPlanLink: {
                            name: ROUTE_NAME_PROMOTION.PLAN.DETAIL,
                            params: { id: cycle.promotionPlanId }
                        }
                    };
                });
            }
        }
    });

    const getPromotionPlanNameList = async (itemIds: Set<number>) => {
        let promotionPlanNames: Map<number, string> = new Map();
        await executeAction({
            request: () => promotionService.plan.listInIds(Array.from(itemIds).join(',')),
            onSuccess: ({ data }) => {
                promotionPlanNames = new Map<number, string>(data.map((item: any) => [item.id, item.name]));
            }
        })();

        return promotionPlanNames;
    };

    return { list, total, query, fetchList };
}
